import React, { useState, useEffect, useContext } from "react";
import Stepper from "react-stepper-horizontal";
import UploadFile from "./Step1/UploadFile";
import Processing from "./Step2/Processing";
import LocationDetails from "./Step3/Location_details";
import TruckandTransporter from "./Step4/TruckandTransporter";
import ConfirmLanes from "./Step5/ConfirmLanes";
import { Urls } from "../../../../../Urls";
import Axios from "../../../../../Axios";
import { toast } from "react-toastify";
import Loader from "../../../../Loader";
// import { CompanyProfileApiContext } from '../../../../../Context/CompanyProfileContext'
import { UserApiContext } from "../../../../UserDetailsContext/UserDetailsContext";
import ValidationErrorDisplay from "./Step6/ValidationErrorDisplay";
import TransporterTable from "./Step7/TransporterTable";
import { MyCompanyProfileContext } from "../../../../../MyCompanyProfileContext";
import axios from "../../../../../Axios";
import { next_page } from "./Utility";
import { useMixPanelForTracking } from "../../../../../utils/TrackMixPanel";

/**
 * Step 0
 * Component for handling the upload and processing of Excel files.
 */
const UploadExcel = ({
  isBulkUpload,
  newStep,
  newexcel_details,
  headerMap,
  setNewStep,
  floatFromFM,
  setMainStep,
  setFile,
  setFinalKeys,
  setFloatFromFM,
  setData,
  setSelectedFileFormat,
  setUploadedFileFormat,
  emailTemplate,
  superAdmins,
  selectedOrg
}) => {
  const [step, setStep] = useState(0);
  const [show, setshow] = useState(false);
  const [details, setDetails] = useState([]);
  const [excel_details, setExcel_details] = useState({});
  const [location_details, setLocation_details] = useState([]);
  const [truck_details, setTruck_details] = useState([]);
  const [transporter_details, setTransporter_details] = useState([]);
  const [PreviosStep, setPreviosStep] = useState(0);
  const [validationErrors, setValidationErrors] = useState();
  const { companyProfile, userDetails } = useContext(UserApiContext); // Assuming userDetails is here
  const [existingLanes, setExistingLanes] = useState([]);
  const { companySettingData } = useContext(MyCompanyProfileContext);

  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  const trackNextStep = (nextStep, actiontext) => {
    const excelID = excel_details?.excel_id || newexcel_details?.excel_id || "N/A";
    
    if (isBulkUpload) {
      setNewStep(nextStep);
    } else {
      setStep(nextStep);
    }

    TrackMixPanel({
        ModuleName: "freight master",
        ScreenName: "bulk upload stepper",
        Definition: actiontext,
        Data: `excel id: ${excelID}, current step: ${isBulkUpload ? newStep : step}, next step: ${nextStep}`,
    });
  };

  useEffect(() => {
    if (isBulkUpload) {
      setStep(newStep);
      setExcel_details(newexcel_details);
    }
  }, [newexcel_details]);

  useEffect(() => {
    if (!isBulkUpload) {
      setStep(0);
      var current_excel_details = {};
      Axios.get(`${Urls.freight_master}?field=excel_logs`)
        .then((res) => {
          if (res.data && res.data.data && res.data.data.length > 0) {
            const current_excel_details =
              res.data.data.find(
                (obj) =>
                  (!("module" in obj) || obj.module !== "indent") &&
                  obj?.page !== "completed"
              ) || res.data.data[0];
            if (current_excel_details.excel_id) {
              setExcel_details(current_excel_details);
            }
            if (current_excel_details && current_excel_details.page) {
              if (current_excel_details.page === "location") {
                setPreviosStep(0);
                setStep(2);
              } else if (current_excel_details.page === "truckandtransporter") {
                setPreviosStep(0);
                setStep(3);
              } else if (current_excel_details.page === "confirmlanes") {
                setPreviosStep(0);
                setStep(4);
              }
            }
          }
        })
        .catch((err) => {
          setshow(false);
          toast.error("Incorrect File Uploaded");
          console.error(err);
        });
    }
  }, [isBulkUpload]);
  const mapStep = (inputStep, isBulkUpload) => {
    if (!isBulkUpload) return inputStep;

    const mapping = {
      0: 0, // Upload Files
      1: 1, // Processing
      2: 3, // Check Your Locations
      3: 4, // Check your truck type and transporter
      4: 5, // Confirm Lanes
      5: 2, // Upload Error(s)
    };

    return mapping[inputStep] ?? inputStep;
  };

  const setLocations = (location_list) => {
    var temp = [];
    if (location_list.unique_df && location_list.unique_df.length > 0) {
      location_list.unique_df.map((loc) => {
        loc.main_location = loc.main_location ? loc.main_location : {};
        loc.type = "unique";
        temp.push(loc);
      });
    }
    if (location_list.not_found_new && location_list.not_found_new.length > 0) {
      location_list.not_found_new.map((loc) => {
        loc.main_location = loc.main_location ? loc.main_location : {};
        loc.type = "not_found";
        temp.push(loc);
      });
    }
    if (location_list.multistate && location_list.multistate.length > 0) {
      location_list.multistate.map((loc) => {
        loc.type = "multistate";
        loc.main_location = loc.main_location ? loc.main_location : {};
        temp.push(loc);
      });
    }
    if (location_list.no_spellsugg && location_list.no_spellsugg.length > 0) {
      location_list.no_spellsugg.map((loc) => {
        loc.type = "no_spellsugg";
        loc.main_location = loc.main_location ? loc.main_location : {};
        temp.push(loc);
      });
    }
    temp.sort((a, b) => a.index - b.index);
    setLocation_details(temp);
  };

  const setTrucks = (trucks_list) => {
    var temp_truck_list = [];
    if (trucks_list.trk_spell && trucks_list.trk_spell.length > 0) {
      trucks_list.trk_spell.map((trucks) => {
        trucks.type = "spell";
        temp_truck_list.push(trucks);
      });
    }
    if (trucks_list.trk_matched && trucks_list.trk_matched.length > 0) {
      trucks_list.trk_matched.map((trucks) => {
        trucks.type = "matched";
        temp_truck_list.push(trucks);
      });
    }
    temp_truck_list.sort((a, b) => a.index - b.index);
    setTruck_details(temp_truck_list);
  };

  const setTransporters = (vendors_list) => {
    var temp_transporter_list = [];
    if (vendors_list.ven_spell && vendors_list.ven_spell.length > 0) {
      vendors_list.ven_spell.map((transporter) => {
        transporter.type = "spell";
        temp_transporter_list.push(transporter);
      });
    }
    if (vendors_list.ven_matched && vendors_list.ven_matched.length > 0) {
      vendors_list.ven_matched.map((transporter) => {
        transporter.type = "matched";
        temp_transporter_list.push(transporter);
      });
    }
    temp_transporter_list.sort((a, b) => a.index - b.index);
    setTransporter_details(temp_transporter_list);
  };

  const splitIndents = (newindents) => {
    let splittedIndents = [];

    newindents.forEach((lane) => {
      const trucks = parseInt(lane.truck_required, 10);

      lane.shortlisted_transporters &&
        lane.shortlisted_transporters.length > 0 &&
        lane.shortlisted_transporters.map((data) => {
          data.rank && typeof data.rank === "string"
            ? data.rank.includes("L")
              ? (data.rank = data.rank.replace(/L(?=.*L)/g, ""))
              : (data.rank = `L${data.rank}`)
            : (data.rank = `L${data.rank}`);
        });

      for (let i = 0; i < trucks; i++) {
        const newData = {
          ...lane,
          truck_required: "1", // Set truck required to "1" for each new entry
        };
        splittedIndents.push(newData);
      }
    });
    return splittedIndents;
  };

  const createMultipleIndents = (lane_details) => {
    const expiryHours =
      companySettingData &&
      companySettingData.indent &&
      companySettingData.indent.indent_auto_expiry_enable === "yes"
        ? parseInt(companySettingData.indent.indent_expiry)
        : 0;

    const finalPayload = lane_details.map((lane) => {
      const placementDate = lane.$date?.$date
        ? new Date(lane.$date?.$date).toISOString().split("T")[0]
        : new Date().toISOString().split("T")[0];

      let expiryDateTime = null;
      if (expiryHours > 0) {
        const expiryDate = new Date();
        expiryDate.setHours(expiryDate.getHours() + expiryHours);

        const year = expiryDate.getFullYear();
        const month = ("0" + (expiryDate.getMonth() + 1)).slice(-2);
        const day = ("0" + expiryDate.getDate()).slice(-2);
        const hour = ("0" + expiryDate.getHours()).slice(-2);
        const minute = ("0" + expiryDate.getMinutes()).slice(-2);
        const second = ("0" + expiryDate.getSeconds()).slice(-2);

        expiryDateTime = `${year}-${month}-${day} ${hour}:${minute}:${second}.000000`;
      }

      return {
        origin: lane.origin,
        destination: lane.destination,
        truck_types: lane.truck_types,
        truck_required: Number(lane.truck_required),
        placement_date: placementDate,
        shortlisted_transporters: lane.transporter_details,
        expiry_date: expiryDateTime,
      };
    });

    axios
      .post(Urls.createMultipleIndent, { indents: splitIndents(finalPayload) })
      .then((res) => {
        if (res && res.data && res.data.error) {
          toast.error(res.data.error);
          setshow(false);
          // throw new Error(res.data.error);
        } else {
          toast.success("Indents floated successfully");
          const excelID = localStorage.getItem("fm_excel_id") || "";
          if (excelID !== "") {
            next_page({
              data: "completed",
              excel_id: excelID,
              key: "page",
            });
          }
          setshow(false);
          document.getElementById("close_contactus1").click();
          TrackMixPanel({
            ModuleName: "freight master",
            ScreenName: "bulk upload stepper",
            Definition: "bulk indent upload completed successfully",
            Data: `excel id: ${excelID}, number of indents: ${splitIndents(finalPayload).length}`,
          });
        }
      })
      .catch((err) => {
        console.error(err, "err");
        setshow(false);
      });
  };
  const fetch_cleaning_details = async (url, excel_id, from) => {
    setshow(true);
    let payload = {
      file_url: url?.split("?")[0],
      excel_id: excel_id,
      ...(isBulkUpload && { mapping_header: headerMap }),
    };
    await Axios.post(
      `${Urls.freight_master}?action=freight_excel_cleaning`,
      payload
    )
      .then((response) => {
        if (response && response.data.status === "error") {
          isBulkUpload ? setNewStep(5) : setStep(5);
          setValidationErrors(response.data);
          setshow(false);
          return;
        }

        if (response && response.data) {
          setLocations(response.data);
          setTrucks(response.data);
          setTransporters(response.data);
          if (from === "from_upload") {
            isBulkUpload ? setNewStep(2) : setStep(2);
          } else {
            if (excel_details.page === "location") {
              isBulkUpload ? setNewStep(2) : setStep(2);
            } else if (excel_details.page === "truckandtransporter") {
              isBulkUpload ? setNewStep(3) : setStep(3);
            }
          }
        }
        setshow(false);
      })
      .catch((err) => {
        console.error(err);
        setshow(false);
      });
  };

  const fetch_saved_details = (excel_id) => {
    Axios.post(`${Urls.freight_master}?action=get_saved_data`, {
      excel_id: excel_id,
    })
      .then((response) => {
        if (response.data) {
          setLocations(response.data);
          setTrucks(response.data);
          setTransporters(response.data);
        }
      })
      .catch((err) => {
        setshow(false);
        console.error(err);
      });
  };

  return (
    <>
      <Loader show={show} />
      <div className="w-100">
        <Stepper
          steps={[
            { title: "Upload Files" },
            { title: "Processing" },
            ...(isBulkUpload ? [{ title: "Upload Error(s)" }] : []),
            { title: "Check Your Locations" },
            { title: "Check your truck type and transporter" },
            { title: "Confirm Lanes" },
          ]}
          activeStep={mapStep(newStep ?? step, isBulkUpload)}
          completeColor="#54a63a"
          completeTitleColor="#54a63a"
          activeColor="#393186"
          activeTitleColor="#393186"
          titleFontSize={14}
          size={28}
          circleFontSize={14}
        />

        {(isBulkUpload ? newStep : step) === 0 && (
          <UploadFile
            selectedOrg={selectedOrg}
            step={isBulkUpload ? newStep : step}
            setStep={isBulkUpload ? setNewStep : setStep}
            setExcel_details={setExcel_details}
            location_details={location_details}
            setLocation_details={setLocation_details}
            truck_details={truck_details}
            setTruck_details={setTruck_details}
            transporter_details={transporter_details}
            setTransporter_details={setTransporter_details}
            details={details}
            setDetails={setDetails}
            fetch_cleaning_details={fetch_cleaning_details}
            companyProfile={companyProfile}
            TrackMixPanel={TrackMixPanel} 
          />
        )}

        {(isBulkUpload ? newStep : step) === 1 && (
          <Processing
            step={isBulkUpload ? newStep : step}
            setStep={isBulkUpload ? setNewStep : setStep}
          />
        )}

        {(isBulkUpload ? newStep : step) === 2 && (
          <LocationDetails
            selectedOrg={selectedOrg}
            step={isBulkUpload ? newStep : step}
            setStep={isBulkUpload ? setNewStep : setStep}
            PreviosStep={PreviosStep}
            companyProfile={companyProfile}
            setPreviosStep={setPreviosStep}
            fetch_saved_details={fetch_saved_details}
            fetch_cleaning_details={fetch_cleaning_details}
            excel_details={excel_details}
            setExcel_details={setExcel_details}
            location_list={location_details}
            setLocation_list={setLocation_details}
            isBulkUpload={isBulkUpload}
            emailTemplate={emailTemplate}
            superAdmins={superAdmins}
          />
        )}

        {(isBulkUpload ? newStep : step) === 3 && (
          <TruckandTransporter
            selectedOrg={selectedOrg}
            step={isBulkUpload ? newStep : step}
            setStep={isBulkUpload ? setNewStep : setStep}
            companyProfile={companyProfile}
            PreviosStep={PreviosStep}
            setPreviosStep={setPreviosStep}
            trucks={truck_details}
            fetch_saved_details={fetch_saved_details}
            fetch_cleaning_details={fetch_cleaning_details}
            excel_details={excel_details}
            settrucks={setTruck_details}
            transporters={transporter_details}
            settransporter={setTransporter_details}
            isBulkUpload={isBulkUpload}
          />
        )}

        {(isBulkUpload ? newStep : step) === 4 && (
          <ConfirmLanes
            selectedOrg={selectedOrg}
            step={isBulkUpload ? newStep : step}
            companyProfile={companyProfile}
            setStep={isBulkUpload ? setNewStep : setStep}
            setExistingLanes={setExistingLanes}
            excel_details={excel_details}
            PreviosStep={PreviosStep}
            setPreviosStep={setPreviosStep}
            fetch_saved_details={fetch_saved_details}
            isBulkUpload={isBulkUpload}
            headerMap={headerMap}
            floatFromFM={floatFromFM}
            createMultipleIndents={createMultipleIndents}
            setValidationErrors={setValidationErrors}
            emailTemplate={emailTemplate}
            superAdmins={superAdmins}
          />
        )}
        {(isBulkUpload ? newStep : step) === 5 && (
          <ValidationErrorDisplay
          selectedOrg={selectedOrg}
            errorResponse={validationErrors}
            setMainStep={setMainStep}
            setData={setData}
            setFinalKeys={setFinalKeys}
            setFile={setFile}
            setFloatFromFM={setFloatFromFM}
            setSelectedFileFormat={setSelectedFileFormat}
            setUploadedFileFormat={setUploadedFileFormat}
          />
        )}
        {(isBulkUpload ? newStep : step) === 6 && (
          <TransporterTable
            selectedOrg={selectedOrg}
            lanes={existingLanes}
            createMultipleIndents={createMultipleIndents}
            setshow={setshow}
            setValidationErrors={setValidationErrors}
            setStep={isBulkUpload ? setNewStep : setStep}
          />
        )}
      </div>
    </>
  );
};

export default UploadExcel;
